
import ERROR_MESSAGES from '../libs/errorMessages';

export default {
  name: 'ALoader',
  props: {
    message: {
      type: String,
      default: '',
    },
    error: {
      type: Boolean,
      default: false,
    },
    errorMessage: {
      type: String,
      default: '',
    },
  },
  computed: {
    resolvedErrorMessage() {
      return this.errorMessage || ERROR_MESSAGES.LOAD_INFO;
    },
  },
};
